import React from 'react';
export function ArrowSlimIcon({ width, height, ...props }: Readonly<React.SVGProps<SVGSVGElement>>) {
	return (
		<svg {...props} fill="none" width={width} height={height} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_2416_3030)">
				<path
					d="M30.6622 47.7714L30.6259 47.7599C29.6098 47.4521 28.559 46.8474 27.6399 45.9461L7.42264 26.1215C6.23256 24.9545 5.56092 23.5839 5.38274 22.3609C5.20486 21.1399 5.51919 20.1597 6.15907 19.5323C6.80164 18.9022 7.8117 18.5894 9.06981 18.7657C10.3271 18.9418 11.7291 19.6045 12.9191 20.7713L30.932 38.4344C31.5094 39.0006 32.4396 39.0006 33.017 38.4344L51.0813 20.721C52.2712 19.5542 53.6732 18.8915 54.9305 18.7154C56.1886 18.5391 57.1987 18.8519 57.8413 19.482C58.4811 20.1094 58.7955 21.0896 58.6176 22.3106C58.4394 23.5336 57.7678 24.9042 56.5777 26.0712L36.3605 45.8958C35.6894 46.5539 34.9465 47.0553 34.1964 47.3978C34.1288 47.4287 34.0636 47.4646 34.0014 47.5052C33.3107 47.956 32.3172 48.1328 31.148 47.8924L31.1155 47.8864C30.9569 47.8574 30.8056 47.8189 30.6622 47.7714Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2416_3030">
					<rect height={64} width={64} fill="white" transform="matrix(0 -1 1 0 0 64)" />
				</clipPath>
			</defs>
		</svg>
	);
}
